import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Box, Typography, Paper } from "@mui/material";
import Header from "./Header";

const QrCodeComponent = ({ message }) => {
  const currentUrl = window.location.href;

  return (
    <div>
      <Header />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bgcolor="#f4f6f9"
        padding="20px"
      >
        <Paper
          elevation={4}
          style={{
            padding: "40px",
            textAlign: "center",
            borderRadius: "10px",
            maxWidth: "400px",
          }}
        >
          <Typography variant="h5" gutterBottom style={{ fontWeight: "bold" }}>
            {message !== ""
              ? message
              : "Scan the QR code on your phone for a better Try-on experience"}
          </Typography>

          <Box
            display="flex"
            justifyContent="center"
            margin="20px 0"
            style={{
              padding: "20px",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <QRCodeCanvas value={currentUrl} size={200} />
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default QrCodeComponent;
